import { AbstractControl, FormArray } from '@angular/forms';
import { ReportType } from '@app/domain/model/report-type';

export function validateReportType() {

  let previousType: ReportType;

  return (reportType: AbstractControl) => {

    const reportForm = reportType.parent;
    if (!reportForm) {
      return null;
    }

    if (!previousType || !reportType.value) {
      previousType = reportType.value;
      return null;
    }

    const purchases = (reportForm.get('purchases') as FormArray).controls;

    if (previousType !== reportType.value) {
      previousType = reportType.value === '' ? null : reportType.value;

      const puchasesWithSpecies = purchases
        .filter((purchase) => purchase.get('species').value)
        .map(
          (purchase) => {
            const species = purchase.get('species');
            species.markAsTouched();
            species.valid ? species.setErrors({ 'invalidSpecies': true }) : species.setErrors(null);
            return purchase;
          });

      if (puchasesWithSpecies.every((purchase) => purchase.get('species').valid)) {
        return null;
      }

      return { invalidSpecies: true };
    } else {
      const hasInvalidSpecies = purchases.some((purchase) => purchase.get('species').invalid && purchase.get('species').value);

      if (hasInvalidSpecies) {
        return { invalidSpecies: true };
      }

      return null;
    }
  };

}
